import React from 'react';
import { Box, Dialog, IconButton, useMediaQuery, useTheme } from '@mui/material';
import { colors } from 'common/theme';
import CloseIcon from '@mui/icons-material/Close';

export const ModalHot = ({
  open,
  onClose,
  children,
  testID,
  maxWidth = 680,
  showCloseButton = true,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isTablet = useMediaQuery(theme.breakpoints.between('md', 'lg'));

  // Responsive padding
  const getPadding = () => {
    if (isMobile) return '28px';
    if (isTablet) return '40px';
    return '32px';
  };

  // Responsive gap
  const getGap = () => {
    if (isMobile) return '20px';
    if (isTablet) return '24px';
    return '24px'; 
  };

  // Responsive close button padding
  const getCloseButtonPadding = () => {
    if (isMobile) return '20px';
    if (isTablet) return '24px';
    return '28px'; // Desktop
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: '24px',
          width: isMobile ? '90%' : isTablet ? '80%' : maxWidth,
          maxWidth: isMobile ? '90%' : maxWidth,
          margin: isMobile ? '16px' : 'auto',
          overflowY: isMobile ? 'auto' : 'hidden',
        },
      }}
    >
      <Box
        testId={testID}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: colors.palette.white,
          gap: getGap(),
          overflow: {
            xs: 'auto',
            md: 'scroll',
          },
        }}
      >
        {/* Close Button Header */}
        {showCloseButton && (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              padding: getCloseButtonPadding(),
              paddingBottom: 0,
            }}
          >
            <IconButton
              testId={`${testID}-close-btn`}
              onClick={onClose}
              sx={{
                padding: '4px',
                color: colors.system.text.subtle,
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        )}

        {/* Content */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
            padding: getPadding(),
            paddingTop: showCloseButton ? 0 : getPadding(),
            gap: getGap(),
            overflow: isMobile ? 'auto' : 'visible',
          }}
        >
          {typeof children === 'function' ? children({ isMobile, isTablet }) : children}
        </Box>
      </Box>
    </Dialog>
  );
};

export default ModalHot;
